import { render, staticRenderFns } from "./AdminView.vue?vue&type=template&id=892c4990&scoped=true"
import script from "./AdminView.vue?vue&type=script&lang=js"
export * from "./AdminView.vue?vue&type=script&lang=js"
import style0 from "./AdminView.vue?vue&type=style&index=0&id=892c4990&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892c4990",
  null
  
)

export default component.exports